import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import useModal from "@/hooks/useModal";
import { onUnmounted, inject } from "vue";
import { useMenuStore } from "@/stores/root/menu";


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
  name: {
    type: String,
    default: "",
  },
  title: {
    type: String,
    default: "",
  },
},
  setup(__props) {

const props = __props;

const menuStore = useMenuStore();

function closeMenu() {
  menuStore.setInactive();
}
const { toggleModal, onModalMounted, onModalDestroy } = useModal();
const modalClass = onModalMounted(props.name, props.title);
onUnmounted(() => {
  onModalDestroy(props.name);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(modalClass)),
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(toggleModal)(__props.name, __props.title), closeMenu()))
  }, [
    _createElementVNode("div", {
      class: "content",
      onModalClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(toggleModal)(__props.name))),
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("span", {
        class: "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toggleModal)(__props.name, __props.title), closeMenu()))
      }, "X"),
      _renderSlot(_ctx.$slots, "default", {
        onModalClose: _cache[1] || (_cache[1] = ($event: any) => (_unref(toggleModal)(__props.name)))
      })
    ], 32)
  ], 2))
}
}

})